import React from "react";
import {
  BarChart3, BookOpen, Building2, CheckCircle2, Clock3, Code2, Cog,
  Cpu, DollarSign, Droplets, Factory, FileText, Flag, FlaskConical,
  Globe2, GraduationCap, Handshake, Heart, Home, Landmark, Leaf,
  Lightbulb, Link2, MapPin, MessageCircle, Network, Puzzle, Quote,
  Scale, ScrollText, Search, ShieldCheck, Sparkles, Star, Stethoscope,
  Target, TreePine, TrendingUp, TriangleAlert, User, Users, UsersRound,
  Wheat, Wrench, Zap,
} from "lucide-react";
import { normalizeNodeIcon } from "../utils/nodeContent.js";

const ICONS = {
  idea: Lightbulb,
  book: BookOpen,
  people: Users,
  world: Globe2,
  balance: Scale,
  target: Target,
  organization: Building2,
  education: GraduationCap,
  research: FlaskConical,
  environment: Leaf,
  care: Heart,
  institution: Landmark,
  evidence: BarChart3,
  practice: Wrench,
  source: Link2,
  star: Star,
  sparkles: Sparkles,
  flag: Flag,
  document: FileText,
  quote: Quote,
  search: Search,
  person: User,
  community: UsersRound,
  handshake: Handshake,
  conversation: MessageCircle,
  network: Network,
  home: Home,
  place: MapPin,
  industry: Factory,
  settings: Cog,
  technology: Cpu,
  code: Code2,
  finance: DollarSign,
  policy: ScrollText,
  puzzle: Puzzle,
  tree: TreePine,
  water: Droplets,
  health: Stethoscope,
  energy: Zap,
  food: Wheat,
  success: CheckCircle2,
  warning: TriangleAlert,
  growth: TrendingUp,
  time: Clock3,
  protection: ShieldCheck,
};

export default function NodeIcon({ name, size = 15, className = "" }) {
  const Icon = ICONS[normalizeNodeIcon(name)];
  return Icon ? <Icon size={size} strokeWidth={1.9} className={className} aria-hidden="true" /> : null;
}
